export interface IPopupCallback {
  opener: 'agent' | 'floating' | undefined;
  isOpen: boolean;
  isLoading: boolean;
  isSuccess: boolean | undefined;
  error: string | undefined;
}

export interface IPopupCallbackToggle {
  opener: 'agent' | 'floating' | undefined;
  isOpen: boolean | undefined;
  type: 'IPopupCallbackToggle';
}

export interface IPopupCallbackRequestStart {
  type: 'IPopupCallbackRequestStart';
}

export interface IPopupCallbackRequestEnd {
  isSuccess: boolean;
  error: string | undefined;
  type: 'IPopupCallbackRequestEnd';
}

export function toggle(opener: 'agent' | 'floating' | undefined, isOpen?: boolean): IPopupCallbackToggle {
  return {
    isOpen,
    opener,
    type: 'IPopupCallbackToggle',
  };
}

const defaultState: IPopupCallback = {
  error: undefined,
  isLoading: false,
  isOpen: false,
  isSuccess: undefined,
  opener: undefined,
};

export function popupCallbackReducer(
  state: IPopupCallback,
  action: IPopupCallbackToggle | IPopupCallbackRequestStart | IPopupCallbackRequestEnd,
): IPopupCallback {
  switch (action.type) {
    case 'IPopupCallbackToggle':
      return {
        ...state,
        isOpen: typeof action.isOpen !== 'undefined' ? (action.isOpen as boolean) : !state.isOpen,
        opener: action.opener,
      };
    case 'IPopupCallbackRequestStart':
      return {
        ...state,
        error: undefined,
        isLoading: true,
        isSuccess: undefined,
      };
    case 'IPopupCallbackRequestEnd':
      return {
        ...state,
        error: action.error,
        isLoading: false,
        isSuccess: action.isSuccess,
      };

    default:
      return state || defaultState;
  }
}
